<div class="query-csv-overlay" id="query-csv-overlay">
  <div class="query-csv-popup" id="query-csv-popup">
    <h3 id="query-csv-title">Consulta CSV/Excel</h3>
    <p id="query-csv-query"><strong id="query-csv-query-label">Consulta:</strong> {{ query }}</p>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" id="query-csv-form">
      <div class="mb-3" id="query-csv-source-group">
        <label for="sourceInput" class="form-label" id="query-csv-source-label">Archivo a analizar</label>
        <select id="sourceInput" class="form-select" formControlName="original_filename">
          <option value="" disabled selected>Selecciona un archivo</option>
          <option *ngFor="let file of csvDocuments; let i = index" [value]="file.original_filename" id="query-csv-source-option-{{i}}">{{ file.original_filename }}</option>
        </select>
      </div>
      <div class="d-flex justify-content-end" id="query-csv-actions">
        <button type="button" class="btn btn-secondary me-2" (click)="onCancel()" id="query-csv-cancel-btn">Cancelar</button>
        <button type="submit" class="btn btn-primary" [disabled]="form.invalid" id="query-csv-submit-btn">Enviar</button>
      </div>
    </form>
  </div>
  
</div>
